import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

/**
 * Generated class for the MenuPartialRatioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-ratio',
    templateUrl: 'menu-partial-ratio.html',
})
export class MenuPartialRatioPage {
    @Input() color: string;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }



}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-list/menu-partial-ratio/menu-partial-ratio.ts